import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class PlaceAction extends AbstractProvidedClass {
    constructor(provider, elements, x, y) {
        super(provider);

        this.cloneElements = elements
        this.x = x;
        this.y = y;
    }

    finish() {
        this.newElements = this.cloneElements.map((el) => {
            let clone = el.clone(this.x, this.y)
            this.elements.add(clone);
            return clone;
        });
        this.actions.finish();
        return this.newElements;
    }

    undo() {
        this.elements.delete(this.newElements);
    }

    redo() {
        this.newElements.map((el) => {
            this.elements.add(el);
        });
    }
}
